import { Injectable } from '@angular/core';
import { environment } from '../../environments/environment';
import { ApiService } from './api.service';
import { Store } from '../store';
import { catchError, map } from 'rxjs/operators';
import { ApiAuthHttpClient } from '../http/ApiAuthHttpClient';

@Injectable({
    providedIn: 'root'
})
export class ErrorReportingService {
    env = environment;

    constructor(
        private apiService: ApiService,
        private http: ApiAuthHttpClient,
        private store: Store,
    ) {
    }

    findOne(id) {
        return this.http.get(this.env.apiPath + 'error-reporting/' + id, this.apiService.getHttpOptions())
            .pipe(
                map((data: any) => {
                    return data;
                },
                    catchError(this.apiService.handleError)
                ));
    }

    search(params) {
        const dataToSend = {
            params,
        };
        return this.http.post(this.env.apiPath + 'error-reporting/search', dataToSend, this.apiService.getHttpOptions())
            .pipe(
                map((data: any) => {
                    return data;
                },
                    catchError(this.apiService.handleError)
                )
            );
    }

}
